import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import CO2Service from '~/api/services/co2'
import Dialog from '~/components/Dialog'
import { Nullable } from '~/types'
import { handleErrors } from '~/utils/helpers'
import Results from '~/pages/Farmer/Co2Climate/AnswerCO2Climate/Steps/Results'
import { useParams } from 'react-router-dom'

interface Props {
  farmerId: Nullable<string>
  handleClose: () => void
  uniqueId: Nullable<string>
}

const PreviewModal: React.FC<Props> = (props) => {
  const { farmerId, handleClose, uniqueId } = props
  const { t } = useTranslation()
  const { id } = useParams()

  const [submitPreviewData, setSubmitPreviewData] = useState(false)
  const [isBusy, setIsBusy] = useState(false)

  useEffect(() => {
    if (farmerId) {
      fetchPreviewData()
    }
  }, [farmerId])

  async function fetchPreviewData() {
    setIsBusy(true)
    try {
      const response = await CO2Service.getCO2FarmerResults(id, farmerId)
      setSubmitPreviewData(response.data)
    } catch (error) {
      handleErrors(error)
    }
    setIsBusy(false)
  }

  return <Dialog
    isDialogOpen={Boolean(farmerId)}
    isLoading={isBusy}
    textHeader={t('GHG emission results for data collection {{id}}', { id: uniqueId })}
    textContent={<>
      <Results results={submitPreviewData} removeMargin />
    </>}
    handleClose={() => handleClose()}
    textClose={t('Close')}
  />

}
export default PreviewModal